<section class="latest-news section-gap">
    <div class="container">
        <div class="section-title text-center mb-30 wow fadeInUp" data-wow-delay="0.3s">
            <span class="title-tag">Latest News</span>
            <h2 class="title"> Read Our Latest <br> News & Blog </h2>
        </div>
        <div class="row justify-content-center">
            <!-- Data -->
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp" data-wow-delay="0.7s" *ngFor="let item of blogblock | slice:0:3">
                <div class="latest-news-box mt-30">
                    <div class="post-thumb">
                        <img [src]="item.gridimg" [alt]="item.title">
                    </div>
                    <div class="post-content">
                        <ul class="post-meta">
                            <li *ngFor="let user of getAuthor(item.author)"><a routerLink="/blog/author/{{user.id}}">By {{user.name}},</a></li>
                            <li><a routerLink="/blog-details/{{item.id}}">{{item.postdate}}</a></li>
                        </ul>
                        <h4 class="title">
                            <a routerLink="/blog-details/{{item.id}}">{{item.title}}</a>
                        </h4>
                        <a routerLink="/blog-details/{{item.id}}" class="read-more-btn">Read More <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <!-- Data -->
        </div>
    </div>
</section>